export default "__VITE_ASSET__HLhTgVKN__"